import React from 'react';
import type { BBCommonProps } from 'types/story';

const LottieComponent = React.lazy(() => import('./LottieComponent'));

const Lottie: React.FC<BBCommonProps> = props => {
	return (
		<React.Suspense fallback={null}>
			<LottieComponent {...props} />
		</React.Suspense>
	);
};

export default Lottie;
